import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac089b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-detail" }
const _hoisted_2 = { class: "plan-detail-head" }
const _hoisted_3 = { class: "plan-detail-head-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fanhui" }, null, -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "search-content" }
const _hoisted_7 = { class: "search-flex" }
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "THE CKB注文番号", -1))
const _hoisted_10 = { class: "search-input" }
const _hoisted_11 = { class: "search-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "注文(Shopify)", -1))
const _hoisted_13 = { class: "search-input" }
const _hoisted_14 = { class: "search-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "お客様注文番号", -1))
const _hoisted_16 = { class: "search-input" }
const _hoisted_17 = { class: "search-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "宛先", -1))
const _hoisted_19 = { class: "search-input" }
const _hoisted_20 = { class: "search-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "件名", -1))
const _hoisted_22 = { class: "search-input" }
const _hoisted_23 = { class: "search-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "ステータス", -1))
const _hoisted_25 = { class: "search-input" }
const _hoisted_26 = { class: "search-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search-title" }, "処理日時", -1))
const _hoisted_28 = { class: "search-input" }
const _hoisted_29 = { class: "search-btn" }
const _hoisted_30 = { style: {"padding":"16px","background-color":"#fff"} }
const _hoisted_31 = { class: "email-detail" }
const _hoisted_32 = { class: "email-detail-info" }
const _hoisted_33 = { class: "email-detail-section" }
const _hoisted_34 = { class: "email-detail-section-title" }
const _hoisted_35 = { class: "email-detail-subject" }
const _hoisted_36 = { class: "email-detail-section email-detail-body-section" }
const _hoisted_37 = { class: "email-detail-section-title" }
const _hoisted_38 = ["innerHTML"]

import { useRoute, useRouter } from 'vue-router'
import STable from '@/components/Table/index.vue'
import SendEmailDrawer from './SendEmailDrawer.vue'
import { t } from '@/plugins/i18n'
import { computed, nextTick, onMounted, ref } from 'vue'
import { request } from '@/config/request/interceptors'
import { BizResponsePageShopEmailHistoryRespDTO, ShopEmailHistoryPageReqDTO, ShopEmailHistoryRespDTO } from '@/service/customer'
import { PlatformOrderEmailPreviewRespDTO } from '@/service/order'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getJapanTime } from '@/util/common'

type PlatformOrderEmailPreviewPayload = PlatformOrderEmailPreviewRespDTO & {
  customerShopId?: number
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const statusEnum = {
  SENDING: '送信中',
  SUCCESS: '送信済み',
  FAILED: '送信失敗',
  CANCELED: 'キャンセル済み'
}
const columns = [
  {
    label: t('THE CKB注文番号'),
    prop: 'platformOrderNo',
    width: 160
  },
  {
    label: t('注文(Shopify)'),
    prop: 'shopifyOrderName',

    width: 130
  },
  {
    label: t('お客様注文番号'),
    prop: 'shopifyOrderNo',
    width: 130
  },

  {
    label: t('宛先'),
    prop: 'recipientEmail',
    width: 200
  },
  {
    label: t('件名'),
    prop: 'subject',
    width: 320
  },
  {
    label: t('ステータス'),
    prop: 'status',
    slotName: 'status',
    width: 160
    // formatter: (...r: any[]) => {
    //   return statusEnum[r[2]]
    // }
  },
  {
    label: t('処理日時'),
    prop: 'processTime',
    formatter: (...r: any[]) => {
      return getJapanTime(r[2])
    }

  }, {
    label: t('エラー内容'),
    prop: 'displayErrorMessage',
    minWidth: 300
  }
]

const route = useRoute()
/** 创建带 URL 初始参数的查询表单默认值，用于页面首次进入。 */
const createInitialFormData = () => ({
  platformOrderNo: String(route.query.platformOrderNo ?? ''),
  shopifyOrderNo: '',
  recipientEmail: '',
  shopifyOrderName: '',
  subject: '',
  status: '',
  processTime: ''
})
/** 创建重置查询时使用的空表单默认值，忽略 URL 上附带的筛选参数。 */
const createEmptyFormData = () => ({
  platformOrderNo: '',
  shopifyOrderNo: '',
  recipientEmail: '',
  shopifyOrderName: '',
  subject: '',
  status: '',
  processTime: ''
})
const searchData = ref<ShopEmailHistoryPageReqDTO>({
  platformOrderNo: route.query.platformOrderNo ?? ''
})
const formData = ref<any>(createInitialFormData())
const pageData = ref({
  page: 1,
  limit: 30
})
const tableRef = ref()
const tableConfig = ref({
  showHandler: true,
  handlerConfig: {
    width: 240,
    // 操作栏的宽度
    handleWidth: 240
  },
  rowKey: 'id'
})
const detailVisible = ref(false)
const detailData = ref<ShopEmailHistoryRespDTO>({})
const cancelLoading = ref(false)
const sendEmailDrawerRef = ref()
/** 再送信前的邮件预览接口扩展返回结构。 */
const detailStatusText = computed(() => {
  const status = detailData.value.status ? statusEnum[detailData.value.status as keyof typeof statusEnum] : ''
  if (!status) return '-'
  return detailData.value.processTime ? `${getJapanTime(detailData.value.processTime)} に${status}` : status
})
const isDetailFailed = computed(() => detailData.value.status === 'FAILED')

/** 将模板场景枚举转换成页面展示用的日文文案。 */
const getTemplateSceneName = (scene?: string) => {
  /** 模板场景对应的日文名称映射。 */
  const sceneMap: Record<string, string> = {
    NORMAL: t('通常出荷メール'),
    PARTIAL: t('一部分納出荷メール'),
    FINAL: t('最終出荷メール')
  }
  return scene ? sceneMap[scene] || scene : ''
}

const router = useRouter()
const openDetail = (row: ShopEmailHistoryRespDTO) => {
  detailData.value = { ...row }
  detailVisible.value = true
}
const closeDetail = () => {
  detailVisible.value = false
}
const refreshTable = () => {
  nextTick(() => {
    tableRef.value?.getData()
  })
}
/** 将预览接口返回的最新邮件内容合并到邮件历史行数据里。 */
const buildPreviewEmailRow = (row: ShopEmailHistoryRespDTO, preview?: PlatformOrderEmailPreviewRespDTO) => {
  /** 再送信前的最新预览数据。 */
  const previewPayload = preview as PlatformOrderEmailPreviewPayload | undefined
  return {
    ...row,
    shopifyOrderNo: row.shopifyOrderName || row.shopifyOrderNo,
    recipientEmail: previewPayload?.recipientEmail || row.recipientEmail,
    subject: previewPayload?.subject || row.subject,
    content: previewPayload?.content || row.content,
    deliveryTaskCode: previewPayload?.deliveryTaskCode || row.deliveryTaskCode,
    itemLoopContent: previewPayload?.itemLoopContent || row.itemLoopContent,
    templateScene: previewPayload?.templateScene || row.templateScene,
    customerShopId: previewPayload?.customerShopId || row.customerShopId,
    orderNo: previewPayload?.orderNo || row.orderNo,
    items: previewPayload?.items || row.items,
    variableMap: previewPayload?.variableMap || row.variableMap
  }
}
/** 再送信前先调用预览接口，确保弹窗展示的是最新邮件详情。 */
const openSendDrawer = async (row: ShopEmailHistoryRespDTO & { sendEmailLoading?: boolean }) => {
  if (row.sendEmailLoading) return
  row.sendEmailLoading = true
  try {
    const res = await request.order.customer.platformOrderEmailPreview({
      customerShopId: row.customerShopId,
      platformOrderNo: row.platformOrderNo,
      orderNo: row.orderNo
    })
    if (!res.success || !res.data?.canPreview) {
      res.data?.reason && ElMessage.warning(res.data.reason)
      return
    }
    sendEmailDrawerRef.value?.open(buildPreviewEmailRow(row, res.data))
  } finally {
    row.sendEmailLoading = false
  }
}
const openDetailSendDrawer = async () => {
  const row = { ...detailData.value }
  closeDetail()
  nextTick(() => {
    openSendDrawer(row)
  })
}
const handleCancel = async (row:any) => {
  const historyId = row.id ?? detailData.value.id
  if (!historyId || cancelLoading.value) return
  await ElMessageBox.confirm(t('キャンセルしてよろしいでしょうか?'), t('提示'), {
    confirmButtonText: t('はい'),
    cancelButtonText: t('いいえ'),
    type: 'warning'
  })
  cancelLoading.value = true
  try {
    const res = await request.customer.aws.shopEmailSendCancel({ historyId })
    if (res.success) {
      ElMessage.success(t('取消成功'))
      closeDetail()
      refreshTable()
    }
  } finally {
    cancelLoading.value = false
  }
}

const search = () => {
  pageData.value.page = 1
  const params: any = {
    ...formData.value
  }
  if (formData.value.processTime) {
    params.processStartTime = `${formData.value.processTime} 00:00:00`
    params.processEndTime = `${formData.value.processTime} 23:59:59`
    delete params.processTime
  }

  searchData.value = params
  nextTick(() => {
    tableRef.value.getData()
  })
}
const reset = () => {
  formData.value = createEmptyFormData()
  search()
}

onMounted(() => {
  formData.value = createInitialFormData()
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElSpace = _resolveComponent("ElSpace")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "link cursor-pt",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
        }, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_unref(t)('返回')), 1)
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('メールの送信履歴')), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_input, {
                modelValue: formData.value.platformOrderNo,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.platformOrderNo) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_input, {
                modelValue: formData.value.shopifyOrderName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.shopifyOrderName) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_input, {
                modelValue: formData.value.shopifyOrderNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.shopifyOrderNo) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_input, {
                modelValue: formData.value.recipientEmail,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.recipientEmail) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_input, {
                modelValue: formData.value.subject,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.subject) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_select, {
                style: {"width":"100%"},
                modelValue: formData.value.status,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.status) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: ""
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('送信中'),
                    value: "SENDING"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('送信済み'),
                    value: "SUCCESS"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('送信失敗'),
                    value: "FAILED"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('キャンセル済み'),
                    value: "CANCELED"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_date_picker, {
                style: {"width":"100%"},
                modelValue: formData.value.processTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.processTime) = $event)),
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: search
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: reset }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(STable, {
          ref: (_value, _refs) => {
            _refs['tableRef'] = _value
            tableRef.value = _value
          },
          api: _unref(request).customer.aws.shopEmailHistoryPage,
          columns: columns,
          filterData: searchData.value,
          tableConfig: tableConfig.value,
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[8] || (_cache[8] = ($event: any) => ((pageData).value = $event))
        }, {
          status: _withCtx(({row}) => [
            _createElementVNode("div", {
              class: _normalizeClass(row.status)
            }, _toDisplayString(_unref(getJapanTime)(row.updateTime)) + _toDisplayString(statusEnum[row.status]), 3)
          ]),
          handler: _withCtx(({ scope }) => [
            _createVNode(_component_ElSpace, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  plain: "",
                  onClick: ($event: any) => (openDetail(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (scope.row.status=='FAILED')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (openSendDrawer(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('再送信')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.status=='FAILED')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      type: "danger",
                      plain: "",
                      loading: cancelLoading.value,
                      onClick: ($event: any) => (handleCancel(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["api", "filterData", "tableConfig", "page-data"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((detailVisible).value = $event)),
      title:  _unref(t)('メール内容'),
      "custom-class": "send-email-detail-drawer",
      size: "50%",
      "append-to-body": "",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_ElSpace, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              plain: "",
              onClick: closeDetail
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
              ]),
              _: 1
            }),
            (_unref(isDetailFailed))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  plain: "",
                  loading: cancelLoading.value,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (handleCancel(detailData.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true),
            (_unref(isDetailFailed))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  onClick: openDetailSendDrawer
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('再送信')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('注文(Shopify)')) + "：" + _toDisplayString(detailData.value.shopifyOrderNo || '-'), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('宛先')) + "：" + _toDisplayString(detailData.value.recipientEmail || '-'), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('ステータス')) + "：" + _toDisplayString(_unref(detailStatusText)), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('テンプレート')) + "：" + _toDisplayString(getTemplateSceneName(detailData.value.templateScene) || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('件名')), 1),
            _createElementVNode("div", _hoisted_35, _toDisplayString(detailData.value.subject || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('本文')), 1),
            _createElementVNode("div", {
              class: "email-detail-body",
              innerHTML: detailData.value.content || '-'
            }, null, 8, _hoisted_38)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(SendEmailDrawer, {
      ref: (_value, _refs) => {
        _refs['sendEmailDrawerRef'] = _value
        sendEmailDrawerRef.value = _value
      },
      onSuccess: refreshTable
    }, null, 512)
  ]))
}
}

})